import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";

export const getTextTransformOptions = (
  defaultValue: string = "none",
): StyleValue => ({
  type: "select",
  value: defaultValue,
});

export const getFontStyleOptions = (
  defaultValue: string = "normal",
): StyleValue => ({
  type: "select",
  value: defaultValue,
});

export const getFontWeightOptions = (
  defaultValue: string = "500",
): StyleValue => ({
  type: "select",
  value: defaultValue,
});

export const getFontSizeOptions = (
  defaultValue: string = "16px",
): StyleValue => ({
  type: "slider",
  value: defaultValue,
});

export const getLineHeightOptions = (
  defaultValue: string = "1.5",
): StyleValue => ({
  type: "number",
  value: defaultValue,
});

export const getTextAlignOptions = (
  defaultValue: string = "left",
): StyleValue => ({
  type: "alignment",
  value: defaultValue,
});

export const getColorOptions = (
  defaultValue: string = "#000000",
): StyleValue => ({
  type: "color",
  value: defaultValue,
});

export const getTextDecorationOptions = (
  defaultValue: string = "none",
): StyleValue => ({
  type: "select",
  value: defaultValue,
});

export const getFontPickerOptions = (
  defaultValue: string = "Inter",
): StyleValue =>
  ({
    type: "font-picker",
    value: defaultValue,
  }) as const;
